<template>

    <change-username-form
        :current-username="getHrUser.username"
        :user-uuid="getHrUser.uuid"
        @usernameChangeCompleted="usernameChangeCompleted"
    ></change-username-form>

</template>

<script>

import { mapGetters } from 'vuex';
import ChangeUsernameForm from "../../../components/Users/ChangeUsernameForm";

export default {

    components: {
        ChangeUsernameForm,
    },

    computed: {
        ...mapGetters([
            'getAuth',
            'getHrUser',
        ]),
    },

    metaInfo: {
        title:'Gebruikersnaam wijzigen',
    },

    methods: {
        usernameChangeCompleted() {
            this.$emit('updateUserData');
            this.$router.push({name:'hr.users.show', params:{uuid: this.getHrUser.uuid}});
        },
    },

    name:'HrUsersChangeUsername',

}

</script>
